import { render, staticRenderFns } from "./NumberCSS.vue?vue&type=template&id=6216bf7e&"
import script from "./NumberCSS.vue?vue&type=script&lang=js&"
export * from "./NumberCSS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports